module.exports = __webpack_public_path__ + "img/social-wechat.fddf5edf.svg";